import dayjs from 'dayjs'

export function exportTableFeature (DOMElement, gridApi) {
  activateExport(DOMElement, gridApi)
}

function activateExport (DOMElement, gridApi) {
  DOMElement.innerHTML = '<div class="button is-small" d-action="exportTable" id="exportTableButton">Export</div>'
  DOMElement.classList.add('block')

  DOMElement.addEventListener('click', function () {
    executeExport(gridApi)
  })
}

function executeExport (gridApi) {
  console.log('executeExport', gridApi)
  if (!gridApi.exportDataAsCsv) return

  const fileName = `interco-transactions-${dayjs().format('YYYY-MM-DD HH:mm:ss')}.csv`

  gridApi.exportDataAsCsv({
    skipPinnedTop: true,
    fileName: function (api, context) {
      console.log('fileName', api, context)
      console.log('fileName', fileName)
      return fileName
    }
  })
}
